
import { Link, useLocation, useNavigate } from "react-router-dom";
import Firma from "./Firma";
import Sesion from "./Sesion";

const options = [
    { id: 1, name: "Home", link: "/admin", icon: "bi bi-columns-gap" },
    { id: 4, name: "About", link: "/admin/about", icon: "bi bi-chat-left-text-fill" },
    { id: 2, name: "Portafolio", link: "/admin/portafolio", icon: "bi bi-folder2-open" },
    { id: 5, name: "lab", link: "/admin/lab", icon: "bi bi-eyedropper" },
    { id: 3, name: "Contact", link: "/admin/contact", icon: "bi bi-envelope" },
]

const Menu = () => {
    const { pathname } = useLocation();

   
    return (
        <div className="h-100 bg-white shadow-sm d-flex flex-column align-items-center">
            <strong className=" fs-5 mb-2">
                <Firma logo={true} />
            </strong>

            <ul className="menu nav flex-column">
                {options.map(option => (
                    <li key={option.id} className={`nav-item ${pathname === option.link ? 'actives' : null} `}>
                        <Link to={option.link} className="nav-link fs-5">
                            <strong><i className={`bi ${option.icon}`}></i></strong>
                            {/* <span className="ml-2">{option.name}</span> */}
                        </Link>
                    </li>
                ))}

            </ul>
            <Sesion />
        </div>
    )

}
export default Menu;